import React from 'react';

import {CreatePasswordStrength} from 'presentation/pages/public/components/CreatePasswordStrength';
import {PublicFlowEnum} from 'presentation/pages/public/constants/PublicFlowEnum';

export function Step4Form() {
	return <CreatePasswordStrength flowType={PublicFlowEnum.SIGN_UP} />;
}
